import { POST_QUERY_REQUEST, POST_QUERY_SUCCESS, POST_QUERY_ERROR , POST_QUERY_API_REQUEST, POST_QUERY_API_SUCCESS, POST_QUERY_API_ERROR, POST_QUERY_ARHAM_REQUEST, POST_QUERY_ARHAM_SUCCESS, POST_QUERY_ARHAM_ERROR} from "../types/types";
import { BASEURL2 } from "../../config";
import axios from "axios";
import { getSessionId } from "../../helper/utils";

export const getQuery = (message) => (dispatch) => {
	const sessionId = getSessionId();
	dispatch({ type: POST_QUERY_REQUEST });
	return axios({
		method: "POST",
		url: `https://n8nai.ormeagent.com/webhook/customersupport?session_id=${sessionId}`,
		// headers: { Authorization: `Bearer ${token}` },
		data: { message },
	})
		.then((response) => {
			return dispatch({
				type: POST_QUERY_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: POST_QUERY_ERROR,
				payload: error.response,
			});
		});
};

// export const getQueryApi = (message) => (dispatch) => {
// 	const sessionId = getSessionId();
// 	dispatch({ type:  POST_QUERY_API_REQUEST });
// 	return axios({
// 		method: "POST",
// 		url: `https://n8n.ormeagent.com/webhook/customersupport?session_id=${sessionId}`,
// 		// headers: { Authorization: `Bearer ${token}` },
// 		data: { message },
// 	})
// 		.then((response) => {
// 			return dispatch({
// 				type: POST_QUERY_API_SUCCESS,
// 				payload: response.data,
// 			});
// 		})
// 		.catch((error) => {
// 			return dispatch({
// 				type: POST_QUERY_API_ERROR,
// 				payload: error.response,
// 			});
// 		});
// };



export const getQueryArham = (message) => (dispatch) => {
	const sessionId = getSessionId();
	dispatch({ type:  POST_QUERY_ARHAM_REQUEST });
	return axios({
		method: "POST",
		url: `https://n8n.ormeagent.com/webhook/customersupportapi?session_id=${sessionId}`,
		// headers: { Authorization: `Bearer ${token}` },
		data: { message },
	})
		.then((response) => {
			return dispatch({
				type: POST_QUERY_ARHAM_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: POST_QUERY_ARHAM_ERROR,
				payload: error.response,
			});
		});
};
